import { FC } from "react";
import { Space } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

export interface IActionsCellProps {
  handleEdit?: () => void;
  handleDelete?: () => void;
}

export const ActionsCell: FC<IActionsCellProps> = ({
  handleDelete,
  handleEdit,
}) => {
  return (
    <Space>
      {handleEdit && (
        <EditOutlined onClick={handleEdit} style={{ color: "#1890ff" }} />
      )}
      {handleDelete && (
        <DeleteOutlined onClick={handleDelete} style={{ color: "#FF4D4F" }} />
      )}
    </Space>
  );
};
